import React from 'react'
import { Button } from '@material-ui/core'
import { useStyles } from './styles'

const ReturnButton = ({ onClick }) => {
    const classes = useStyles()
    return (
        <Button className={classes.btn} onClick={onClick}>Volver</Button>
    )
}

export { ReturnButton }